/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentInfo
 */
export interface InvestmentInfo {
    /**
     * 
     * @type {number}
     * @memberof InvestmentInfo
     */
    investmentNo: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentInfo
     */
    investmentName: string;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentInfo
     */
    inceptionDate: Date;
}

/**
 * Check if a given object implements the InvestmentInfo interface.
 */
export function instanceOfInvestmentInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentNo" in value;
    isInstance = isInstance && "investmentName" in value;
    isInstance = isInstance && "inceptionDate" in value;

    return isInstance;
}

export function InvestmentInfoFromJSON(json: any): InvestmentInfo {
    return InvestmentInfoFromJSONTyped(json, false);
}

export function InvestmentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentNo': json['InvestmentNo'],
        'investmentName': json['InvestmentName'],
        'inceptionDate': (new Date(json['InceptionDate'])),
    };
}

export function InvestmentInfoToJSON(value?: InvestmentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentNo': value.investmentNo,
        'InvestmentName': value.investmentName,
        'InceptionDate': (value.inceptionDate.toISOString()),
    };
}

